document.addEventListener("DOMContentLoaded", () => {
    const scrollToTopBtn = document.getElementById("scrollToTopBtn");
  
    // Affiche le bouton après un certain défilement
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1000) {
        scrollToTopBtn.classList.remove("hidden");
      } else {
        scrollToTopBtn.classList.add("hidden");
      }
    });
  
    // Scroll en haut de la page au clic sur le bouton
    if (scrollToTopBtn) {
      scrollToTopBtn.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const tags = document.querySelectorAll(".blog-tag");
    tags.forEach(tag => {
      if (tag) {
        tag.addEventListener("click", function (event) {
          event.preventDefault(); // Empêche le changement immédiat d'URL
          this.classList.toggle("tag-active"); // Ajoute ou enlève la classe
          window.location.href = this.getAttribute("href"); // Redirige vers l'URL du filtre
        });
      }
    });
  });



const buttonHover = document.querySelector('.hover-button');

if (buttonHover) {
  buttonHover.addEventListener('mouseenter', () => {
    button.style.setProperty('--translate-x', '100%');
  });

  buttonHover.addEventListener('mouseleave', () => {
    button.style.setProperty('--translate-x', '-100%');
  });
}



